<script>
import { EventBus } from '@/helpers/eventBus'
import AnimatedNumber from '@/components/common/AnimatedNumber.vue'
export default {
  components: {
    AnimatedNumber
  },
  props: {
    uploaded: { type: Boolean },
    file: { type: File }
  },
  data: () => ({
    percentage: 0
  }),
  computed: {
    isFileInProgress() {
      return !this.uploaded && !this.file.error && !this.file.canceled
    },
    /** Disable cancel-button when there is any failure */
    isCancelDisabled() {
      return this.uploaded || this.file.error || this.file.canceled
    },
    iconColor() {
      if (this.file.error) return 'red darken-4'
      if (this.file.canceled) return 'red darken-4'
      return this.uploaded ? 'success' : 'warning'
    },
    icon() {
      if (this.file.error) return 'mdi-cloud-download'
      if (this.uploaded) return 'mdi-cloud-check'
      if (this.file.canceled) return 'mdi-cloud-off-outline'
      return 'mdi-cloud-sync'
    }
  },
  watch: {
    uploaded() {
      // on any change of the uploaded-state (true / false), disable event-listening
      this.$emit('update:hasError', this.file.error)
      EventBus.$off(
        'uploadPercentage-' + this.file.name + '' + this.file.timestamp,
        this.setPercentage
      )
    }
  },
  created() {
    EventBus.$on(
      'uploadPercentage-' + this.file.name + '' + this.file.timestamp,
      this.setPercentage
    )
  },
  beforeDestroy() {
    EventBus.$off(
      'uploadPercentage-' + this.file.name + '' + this.file.timestamp,
      this.setPercentage
    )
  },
  methods: {
    setPercentage(percentage) {
      this.percentage = percentage
    }
  }
}
</script>
<template>
  <div>
    <v-list-item :ripple="false">
      <v-list-item-avatar class="my-0">
        <v-scroll-x-reverse-transition mode="out-in">
          <v-icon :key="icon" :color="iconColor">{{ icon }}</v-icon>
        </v-scroll-x-reverse-transition>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="overlap">
          {{ file.name }}
        </v-list-item-title>
        <v-expand-transition>
          <v-list-item-subtitle v-if="isFileInProgress" class="primary--text">
            <span><AnimatedNumber :number="Math.ceil(percentage)" />%</span>
          </v-list-item-subtitle>
        </v-expand-transition>
      </v-list-item-content>
      <v-list-item-action class="pa-0 ma-0">
        <v-btn
          icon
          :disabled="isCancelDisabled"
          color="error"
          @click="file.cancelUpload()"
        >
          <v-icon>mdi-delete-forever</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-progress-linear
      v-if="isFileInProgress"
      color="primary"
      :value="percentage"
      height="2"
      rounded
      light
    >
    </v-progress-linear>
    <v-divider></v-divider>
  </div>
</template>
<style lang="scss" scoped>
.overlap {
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-list--two-line .v-list-item {
  min-height: 48px;
}
</style>
